import React, { useMemo } from 'react';
import { LanguageSwitch, Separator } from '@features/ui';
import { languages } from '@constants/languages';
import { useTranslation } from 'react-i18next';

export const BottomNavigation = () => {
  const { t } = useTranslation();

  const bottomNavigations = useMemo(
    () => [
      {
        label: t('common.navigation.term'),
        href: '/',
      },
      {
        label: t('common.navigation.privacy'),
        href: '/',
      },
      {
        label: t('common.navigation.docs'),
        href: '/',
      },
      {
        label: t('common.navigation.helps'),
        href: '/',
      },
    ],
    [t]
  );

  return (
    <footer className="flex flex-wrap lg:flex-nowrap gap-x-3 items-center text-[15px]">
      {bottomNavigations.map((item, index) => (
        <React.Fragment key={item.label}>
          <span className={'font-medium'}>{item.label}</span>
          {index !== bottomNavigations.length - 1 && <Separator dot />}
        </React.Fragment>
      ))}
      <LanguageSwitch
        className="lg:ml-16 xl:ml-20"
        defaultLanguage="en"
        options={languages}
        onChange={() => {}}
      />
    </footer>
  );
};
